var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAngularLogo = function SvgIconAngularLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.25a1 1 0 0 1 .895.553l3.375 6.75a1 1 0 0 1-1.79.894l-.534-1.069h-3.892l-.535 1.07a1 1 0 1 1-1.788-.895l3.375-6.75A1 1 0 0 1 12 7.25m-.946 5.128h1.892L12 10.486z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.615 2.077a1 1 0 0 1 .77 0l9 3.75a1 1 0 0 1 .606 1.055l-1.5 11.25a1 1 0 0 1-.544.762l-7.5 3.75a1 1 0 0 1-.894 0l-7.5-3.75a1 1 0 0 1-.544-.762l-1.5-11.25a1 1 0 0 1 .606-1.055zM4.093 7.378l1.328 9.965 6.58 3.289 6.578-3.29 1.328-9.964L12 4.083z"
  }))));
};
export default SvgIconAngularLogo;